var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    transform: "matrix(-1 0 0 1 31 0.5)",
    stroke: "#2977FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.25C7.08579 11.25 6.75 11.5858 6.75 12C6.75 12.4142 7.08579 12.75 7.5 12.75V11.25ZM25.0303 12.5303C25.3232 12.2374 25.3232 11.7626 25.0303 11.4697L20.2574 6.6967C19.9645 6.40381 19.4896 6.40381 19.1967 6.6967C18.9038 6.98959 18.9038 7.46447 19.1967 7.75736L23.4393 12L19.1967 16.2426C18.9038 16.5355 18.9038 17.0104 19.1967 17.3033C19.4896 17.5962 19.9645 17.5962 20.2574 17.3033L25.0303 12.5303ZM7.5 12.75H24.5V11.25H7.5V12.75Z",
    fill: "#2977FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.75C24.9142 21.75 25.25 21.4142 25.25 21C25.25 20.5858 24.9142 20.25 24.5 20.25V21.75ZM6.96967 20.4697C6.67678 20.7626 6.67678 21.2374 6.96967 21.5303L11.7426 26.3033C12.0355 26.5962 12.5104 26.5962 12.8033 26.3033C13.0962 26.0104 13.0962 25.5355 12.8033 25.2426L8.56066 21L12.8033 16.7574C13.0962 16.4645 13.0962 15.9896 12.8033 15.6967C12.5104 15.4038 12.0355 15.4038 11.7426 15.6967L6.96967 20.4697ZM24.5 20.25L7.5 20.25V21.75L24.5 21.75V20.25Z",
    fill: "#2977FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.568c78ba122a013d70fd54cc2eb9dbdb.svg";
export { ForwardRef as ReactComponent };